import {
  patchHostedBusinessVaultMutation,
  patchHostedUserVaultMutation,
  postHostedBusinessVaultDecryptOptions,
  postHostedUserVaultDecryptOptions,
} from '@onefootprint/fetch-hosted';
import type { VaultKind } from '@onefootprint/request-types';

type DecryptOptions = Parameters<typeof postHostedUserVaultDecryptOptions>[0];
type PatchOptions = Parameters<typeof patchHostedUserVaultMutation>[0];

/**
 * Returns the appropriate decrypt query options based on the vault subject (person or business).
 */
export const getDecryptOptions = (subject: VaultKind, options: DecryptOptions) =>
  subject === 'person' ? postHostedUserVaultDecryptOptions(options) : postHostedBusinessVaultDecryptOptions(options);

/**
 * Returns the appropriate patch vault mutation based on the vault subject (person or business).
 */
export const getPatchVaultMutation = (subject: VaultKind, options: PatchOptions) =>
  subject === 'person' ? patchHostedUserVaultMutation(options) : patchHostedBusinessVaultMutation(options);
